module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige13-6e2e406361344a364b542b32bbafdfcd.jpg";